<ion-card>
  <ion-grid>
    <ion-row>
      <mat-horizontal-stepper linear #stepper>
        <!--#region Credit Card Info-->
        <mat-step [stepControl]="creditCardForm">
          <form [formGroup]="creditCardForm">
            <ng-template matStepLabel>Card Information</ng-template>
            <ion-grid>
              <!--#region Amount-->
              <ion-row>
                <ion-col>
                  <mat-form-field appearance="outline">
                    <mat-label>Amount</mat-label>
                    <input
                      matInput
                      required
                      type="number"
                      name="amount"
                      formControlName="amount"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      creditCardForm.controls.amount.touched &&
                      !creditCardForm.controls.amount.valid
                    "
                    class="cc-error"
                  >
                    <div
                      *ngIf="creditCardForm.controls.amount.errors?.required"
                    >
                      Amount is required
                    </div>
                    <div *ngIf="creditCardForm.controls.amount.errors?.min">
                      Minimum payment is $1.00
                    </div>
                    <div *ngIf="creditCardForm.controls.amount.errors?.max">
                      Maximum payment is {{ amountDue }}
                    </div>
                  </div>
                </ion-col>
              </ion-row>
              <!--#endregion Amount-->

              <!--#region Name & Number-->
              <ion-row>
                <!--#region Name-->
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Name as it appears on the card</mat-label>
                    <input
                      matInput
                      required
                      namePattern
                      type="text"
                      name="name"
                      formControlName="name"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      creditCardForm.controls.name.touched &&
                      !creditCardForm.controls.name.valid
                    "
                    class="cc-error"
                  >
                    <div *ngIf="creditCardForm.controls.name.errors?.required">
                      Name is required
                    </div>
                  </div>
                  <!--#endregion Name-->
                </ion-col>
                <!--#region Number-->
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Card Number</mat-label>
                    <input
                      matInput
                      required
                      numberOnly
                      type="text"
                      name="cardNumber"
                      formControlName="cardNumber"
                      minlength="15"
                      maxlength="16"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      creditCardForm.controls.cardNumber.touched &&
                      !creditCardForm.controls.cardNumber.valid
                    "
                    class="cc-error"
                  >
                    <div
                      *ngIf="
                        creditCardForm.controls.cardNumber.errors?.required
                      "
                    >
                      Card Number is required
                    </div>
                    <div
                      *ngIf="
                        creditCardForm.controls.cardNumber.errors?.minlength
                      "
                    >
                      Card Number must be 15-16 digits
                    </div>
                  </div>
                </ion-col>
                <!--#region Number-->
              </ion-row>
              <!--#endregion Name & Number-->

              <!--#region Expiration & Security Code-->
              <ion-row>
                <!--#region Expiration Month-->
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Expiration Month</mat-label>
                    <mat-select required formControlName="expMonth">
                      <mat-option *ngFor="let m of months" [value]="m">
                        {{ m }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    *ngIf="
                      creditCardForm.controls.expMonth.touched &&
                      !creditCardForm.controls.expMonth.valid
                    "
                    class="cc-error"
                  >
                    <div
                      *ngIf="creditCardForm.controls.expMonth.errors?.required"
                    >
                      Expiration Month is required
                    </div>
                  </div>
                  <div
                    *ngIf="
                      creditCardForm.controls.expYear.touched &&
                      !creditCardForm.valid
                    "
                    class="cc-error"
                  >
                    <div *ngIf="creditCardForm.errors?.expired">
                      The card is expired
                    </div>
                  </div>
                </ion-col>
                <!--#endregion Expiration Month-->

                <!--#region Expiration Year-->
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Expiration Year</mat-label>
                    <mat-select required formControlName="expYear">
                      <mat-option *ngFor="let y of years" [value]="y">
                        {{ y }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    *ngIf="
                      creditCardForm.controls.expYear.touched &&
                      !creditCardForm.controls.expYear.valid
                    "
                    class="cc-error"
                  >
                    <div
                      *ngIf="creditCardForm.controls.expYear.errors?.required"
                    >
                      Expiration Year is required
                    </div>
                  </div>
                  <div
                    *ngIf="
                      creditCardForm.controls.expYear.touched &&
                      !creditCardForm.valid
                    "
                    class="cc-error"
                  >
                    <div *ngIf="creditCardForm.errors?.expired">
                      The card is expired
                    </div>
                  </div>
                </ion-col>
                <!--#endregion Expiration Year-->

                <!--#region Security Code-->
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Security Code</mat-label>
                    <input
                      matInput
                      numberOnly
                      required
                      type="text"
                      name="cvvCode"
                      minlength="3"
                      maxlength="4"
                      formControlName="cvvCode"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      creditCardForm.controls.cvvCode.touched &&
                      !creditCardForm.controls.cvvCode.valid
                    "
                    class="cc-error"
                  >
                    <div
                      *ngIf="creditCardForm.controls.cvvCode.errors?.required"
                    >
                      Security Code is required
                    </div>
                    <div
                      *ngIf="creditCardForm.controls.cvvCode.errors?.minlength"
                    >
                      Security Code must be 3-4 digits
                    </div>
                  </div>
                </ion-col>
                <!--#region Security Code-->
              </ion-row>
              <!--#endregion Expiration-->
            </ion-grid>
            <div>
              <button
                id="btn-next"
                class="step-button"
                [disabled]="!creditCardForm.valid"
                mat-button
                matStepperNext
              >
                Next
              </button>
            </div>
          </form>
        </mat-step>
        <!--#region Credit Card Info-->

        <!--#region Billing Address-->
        <mat-step [stepControl]="billingAddressForm">
          <form [formGroup]="billingAddressForm">
            <ng-template matStepLabel>Billing Address</ng-template>
            <ion-grid>
              <ion-row>
                <!--#region Street-->
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Street</mat-label>
                    <input
                      matInput
                      required
                      type="text"
                      name="street"
                      formControlName="street"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      billingAddressForm.controls.street.touched &&
                      !billingAddressForm.controls.street.valid
                    "
                    class="cc-error"
                  >
                    <div
                      *ngIf="
                        billingAddressForm.controls.street.errors?.required
                      "
                    >
                      Street is required
                    </div>
                  </div>
                </ion-col>
                <!--#endregion Street-->

                <!--#region Line 2-->
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Street Line 2</mat-label>
                    <input
                      matInput
                      type="text"
                      name="line2"
                      formControlName="line2"
                    />
                  </mat-form-field>
                </ion-col>
                <!--#endregion Line 2-->
              </ion-row>
              <ion-row>
                <!--#region Zip Code-->
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>Zip Code</mat-label>
                    <input
                      matInput
                      required
                      zipCode
                      type="text"
                      name="zip"
                      formControlName="zip"
                      (keyup)="onZipChange()"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      billingAddressForm.controls.zip.touched &&
                      !billingAddressForm.controls.zip.valid
                    "
                    class="cc-error"
                  >
                    <div
                      *ngIf="billingAddressForm.controls.zip.errors?.required"
                    >
                      Zip Code is required
                    </div>
                    <div
                      *ngIf="billingAddressForm.controls.zip.errors?.pattern"
                    >
                      Zip Code is invalid
                    </div>
                  </div>
                </ion-col>
                <!--#endregion Zip Code-->
                <!--#region City-->
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>City</mat-label>
                    <input
                      matInput
                      required
                      type="text"
                      name="city"
                      formControlName="city"
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      billingAddressForm.controls.city.touched &&
                      !billingAddressForm.controls.city.valid
                    "
                    class="cc-error"
                  >
                    <div
                      *ngIf="billingAddressForm.controls.city.errors?.required"
                    >
                      City is required
                    </div>
                  </div>
                </ion-col>
                <!--#endregion City-->

                <!--#region State-->
                <ion-col>
                  <mat-form-field class="full" appearance="outline">
                    <mat-label>State</mat-label>
                    <mat-select required formControlName="state">
                      <mat-option *ngFor="let state of states" [value]="state">
                        {{ state }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    *ngIf="
                      billingAddressForm.controls.state.touched &&
                      !billingAddressForm.controls.state.valid
                    "
                    class="cc-error"
                  >
                    <div
                      *ngIf="billingAddressForm.controls.state.errors?.required"
                    >
                      State is required
                    </div>
                  </div>
                </ion-col>
                <!--#endregion State-->
              </ion-row>
            </ion-grid>
            <div>
              <button
                id="btn-prev"
                class="step-button"
                mat-button
                matStepperPrevious
              >
                Back
              </button>
            </div>
          </form>
        </mat-step>
        <!--#endregion Billing Address-->
      </mat-horizontal-stepper></ion-row
    >
    <div>
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-button
          shape="round"
          expand="block"
          class="button-red"
          [disabled]="!creditCardForm.valid || !billingAddressForm.valid"
          (click)="onSubmitPayment()"
        >
          Submit Payment
        </ion-button>
      </ion-row>
    </div>
  </ion-grid>
</ion-card>
